import { BrandclubEventType } from "./types.js";
let debug = false;
let initialized = false;
let loaderScript = null;
let initScript = null;
const PROVIDER = "TheTradeDesk";
const log = (...args) => {
  if (!debug) {
    return;
  }
  console.info(...["[TTD]"].concat(args));
};
function initializeTDDPixel(brandId, pixelLoadUrl, initArgs) {
  if (!initialized && brandId && pixelLoadUrl && initArgs) {
    initialized = true;
    loaderScript = document.createElement("script");
    loaderScript.type = "text/javascript";
    loaderScript.src = pixelLoadUrl;
    document.body.appendChild(loaderScript);
    loaderScript.onload = () => {
      log("initializeTDDPixel", brandId, pixelLoadUrl, initArgs);
      initScript = document.createElement("script");
      initScript.type = "text/javascript";
      initScript.innerHTML = `ttd_dom_ready(function() {
            if (typeof TTDUniversalPixelApi === 'function') {
            var universalPixelApi = new TTDUniversalPixelApi();
            universalPixelApi.init(
                ${JSON.stringify(initArgs[0])},
                ${JSON.stringify(initArgs[1])},
                ${JSON.stringify(initArgs[2])}
            );
        }});`;
      document.body.appendChild(initScript);
    };
  }
}
const tddPixel = {
  enableDebug() {
    debug = true;
  },
  track({ brandId, pixels, eventName, eventType, eventPayload }) {
    const pixel = pixels == null ? void 0 : pixels.find((item) => item.pixelProvider === PROVIDER);
    if (!pixel) {
      return;
    }
    log(JSON.stringify({ brandId, pixels, eventName, payload: eventPayload }));
    initializeTDDPixel(brandId, pixel == null ? void 0 : pixel.pixelLoadUrl, (pixel == null ? void 0 : pixel.pixelInitArgs) ? JSON.parse(pixel.pixelInitArgs) : []);
    if (eventType === BrandclubEventType.PageView) {
      initializeTDDPixel(brandId, pixel == null ? void 0 : pixel.pixelLoadUrl, (pixel == null ? void 0 : pixel.pixelInitArgs) ? JSON.parse(pixel.pixelInitArgs) : []);
    } else if (eventType === BrandclubEventType.OrderSubmitted || eventType === BrandclubEventType.AddToCart) {
      initializeTDDPixel(brandId, pixel == null ? void 0 : pixel.pixelLoadUrl, (pixel == null ? void 0 : pixel.pixelInitArgs) ? JSON.parse(pixel.pixelInitArgs) : []);
    }
  },
  grantConsent() {
    if (!initialized) {
      log("Cannot grant consent - TTD Pixel not initialized");
      return;
    }
    log("TTD Pixel consent granted (managed via initialization)");
  },
  revokeConsent() {
    if (!initialized) {
      log("Cannot revoke consent - TTD Pixel not initialized");
      return;
    }
    log("TTD Pixel consent revoked (managed via initialization)");
  }
};
export {
  tddPixel as default
};
//# sourceMappingURL=tdd.js.map
